import { render } from "./violation.vue?vue&type=template&id=fe766c00&scoped=true"
import script from "./violation.vue?vue&type=script&lang=js"
export * from "./violation.vue?vue&type=script&lang=js"

import "./violation.vue?vue&type=style&index=0&id=fe766c00&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe766c00"]])

export default __exports__